import React from 'react'
import cn from 'classnames'
import styles from './About.module.sass'
import ScrollParallax from '../../ScrollParallax'

const items = [
  {
    title: '5+ years of experience',
    content: 'You have 5 years or more of professional experience as an engineer.',
    color: '#5656EA',
  },
  {
    title: 'Areas of expertise',
    content: 'You are a master of your craft in one or more of our areas of expertise.',
    color: '#9506CE',
  },
  {
    title: 'Better, faster, stronger',
    content:
      'You are always delivering the best software possible because you can’t do it any other way. ',
    color: '#F5A70B',
  },
  {
    title: 'Empathetic & Benevolent',
    content: 'You are a great listener, willing to share your knowledge with peers.',
    color: '#E00054',
  },
]

export const About = () => {
  return (
    <div className={cn('section-border-top', 'section-border-bottom', styles.section)}>
      <div className={cn('container', styles.container)}>
        <div className={styles.row}>
          <div className={styles.col}>
            <div className={cn('stage', styles.stage)}>Requirements</div>
            <h2 className={cn('h2', styles.title)}>Can you become a Guardian?</h2>
            <div className={styles.info}>
              We are looking for experienced Software Engineers willing to take on strategic
              technical topics, give insights and help solve technical problems that other tech
              teams are facing.
            </div>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.list}>
            {items.map((x, index) => (
              <ScrollParallax className={styles.item} key={index}>
                <div className={styles.number} style={{ backgroundColor: x.color }}>
                  0{index}
                </div>
                <div className={styles.subtitle}>{x.title}</div>
                <div className={styles.content}>{x.content}</div>
              </ScrollParallax>
            ))}
          </div>
          <div>
            <div className={styles.image}>
              <ScrollParallax animateIn="fadeIn">
                <img
                  srcSet="img/become-background@2x.png 2x"
                  src="img/become-background@1.5x.png"
                  alt="About background"
                  className={styles.background}
                />
              </ScrollParallax>
              <ScrollParallax className={styles.python} animateIn="fadeInUp" delay={200}>
                <img
                  srcSet="img/become-python@2x.png 2x"
                  src="img/become-python@1.5x.png"
                  alt="Python logo"
                />
              </ScrollParallax>
              <ScrollParallax className={styles.developers} animateIn="fadeInUp" delay={400}>
                <img
                  srcSet="img/become-developers@2x.png 2x"
                  src="img/become-developers@1.5x.png"
                  alt="Developers"
                />
              </ScrollParallax>
              <ScrollParallax className={styles.labels} animateIn="fadeInUp" delay={600}>
                <img
                  srcSet="img/become-labels@2x.png 2x"
                  src="img/become-labels@1.5x.png"
                  alt="Credentials"
                />
              </ScrollParallax>
              <ScrollParallax className={styles.ai} animateIn="fadeInUp" delay={800}>
                <img
                  srcSet="img/become-ai@2x.png 2x"
                  src="img/become-ai@1.5x.png"
                  alt="Credentials"
                />
              </ScrollParallax>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
